// QuilityRx route is hidden (product temporarily inactive)
const routes = [
    // {
    //     path: '/qms/quility-rx',
    //     name: 'QuilityRx',
    //     component: () => import( /* webpackChunkName: "quilityu" */ '../views/QMS/QuilityRx.vue'),
    //     meta: {
    //         title: 'Quility Rx'
    //     },
    // }
]

export default routes